const getTabId = (tabName: string): string => tabName.replace(/\s/g, '');

export default getTabId;
